import {NavigationEnd, Router} from "@angular/router";
import {Injectable} from "@angular/core";
import {filter, pairwise} from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class RouterExtService {
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  constructor(private router : Router) {
    this.currentUrl = this.router.url;

    this.router.events
      .pipe(filter(_event => _event instanceof NavigationEnd), pairwise())
      .subscribe((_events: any[]) => {
        this.previousUrl = _events[0].urlAfterRedirects;
        this.currentUrl = _events[0].url;
      });
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }
}
